<template>
  <el-tabs class="tabs-main" v-model="selfActiveVal" :type="type" @tab-click="tabClick">
    <el-tab-pane v-for="(item, index) in list" :key="index" :name="item.val">
      <template #label>
        <div class="custom-tabs-label">
          <span>{{ item.key }}</span>
          <span
            v-if="JSON.stringify(item.count)"
            :class="{ 'tab-count': true, 'is-red': item.isRed }"
            >{{ item.count }}</span
          >
        </div>
      </template>
      <slot />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: '' // card
    },
    isJump: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      required: true
    },
    activeVal: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selfActiveVal: ''
    }
  },
  mounted() {
    if (this.isJump) {
      this.selfActiveVal = this.$route.path
    } else {
      this.selfActiveVal = this.activeVal
    }
  },
  methods: {
    tabClick() {
      if (this.isJump) {
        this.$router.push(this.selfActiveVal)
      } else {
        this.$emit('update:activeVal', this.selfActiveVal)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.tabs-main {
  .custom-tabs-label {
    display: flex;
    justify-content: center;
    align-items: center;
    .tab-count {
      border-radius: 10px;
      display: inline-block;
      font-size: 12px;
      height: 18px;
      line-height: 18px;
      padding: 0 6px;
      color: #666;
      background: #ddd;
      text-align: center;
      white-space: nowrap;
      border: 1px solid #fff;
      &.is-red {
        color: #fff;
        background-color: #f56c6c;
      }
    }
  }
}
</style>
